<template>
  <div />
</template>

<script>
export default {
  data() {
    return {
      show: false
    }
  },
  created() {
    const that = this
    this.$router.push({
      path: that.$route.query.toPath
    })
  },
  deactivated() {
    this.show = true
  }
}
</script>

<style>

</style>
